<template>
  <v-dialog max-width="500" :value="dialog" @click:outside="close">
    <v-card class="align-center d-flex flex-column py-10 px-7">
      <CloseDialogButton :close="close" />
      <div class="font-size-lg font-weight-semibold mb-5">
        Edit Account Information
      </div>
      <v-form ref="form" v-model="valid" class="full-width">
        <NameInput :name="wait(user, 'name')" :type="'name'" :update="update" />
        <PhoneInput
          :phone="formatPhoneNumber(wait(user, 'phone'))"
          :updatePhone="updatePhone"
          disabled
        />
        <BirthdayInput :date="wait(user, 'birthday')" :update="update" />
        <v-btn
          color="success"
          :disabled="!valid"
          @click.prevent="savePersonalInformation"
          block
          large
          rounded
        >
          <div class="font-size-md font-weight-semibold text-capitalize">
            save
          </div>
        </v-btn>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { formatPhoneNumber, wait } from "@/util.js";
import BirthdayInput from "@/components/Inputs/Birthday.vue";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import NameInput from "@/components/Inputs/Name.vue";
import PhoneInput from "@/components/Inputs/Phone.vue";

export default {
  name: "EditPersonalInformationDialog",
  components: {
    BirthdayInput,
    CloseDialogButton,
    NameInput,
    PhoneInput,
  },
  computed: {
    ...mapState({
      user: (state) => state.user.info,
    }),
  },
  data() {
    return {
      birthday: null,
      name: null,
      phone: null,
      valid: true,
    };
  },
  methods: {
    formatPhoneNumber,
    savePersonalInformation() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      const updates = {
        ...(this.birthday && { birthday: this.birthday }),
        ...(this.name && { name: this.name }),
        ...(this.phone && { phone: this.phone }),
      };

      const changed = Object.keys(updates).length;
      changed && this.save(updates);
      this.close();
    },
    update(name, val) {
      this[name] = val;
    },
    updatePhone(val) {
      this.phone = formatPhoneNumber(val);
    },
    wait,
  },
  props: {
    close: Function,
    dialog: Boolean,
    save: Function,
  },
};
</script>
